import React ,{useEffect, useRef, useState} from 'react';
export default function IntersectionChecker({options, children,
											onIntersectIn, onIntersectOut,onIntersectChange,
											onTopIntersectIn, onBottomIntersectIn,  onTopIntersectOut,onBottomIntersectOut
		}) {


	const intersectionObserverRef = useRef(null);
	const handleIntersectionChange = (e) => {  
		const intersectionEvt = e[0];
		const intersectLocation = intersectionEvt.boundingClientRect
		const windowHeight = window.innerHeight;
		const windowMidHeight = windowHeight/2;
		if(intersectionEvt.isIntersecting === true)
		{
			if(intersectLocation.top < windowMidHeight)
			{
				if(onTopIntersectIn)
				{
					onTopIntersectIn();
				}
			}
			else if(intersectLocation.top > windowMidHeight)
			{
				if(onBottomIntersectIn)
				{
					onBottomIntersectIn();
				}
			}
			if(onIntersectIn)
			{
				onIntersectIn();
			}
		}
		else if(intersectionEvt.isIntersecting === false)
		{
			if(intersectLocation.top < windowMidHeight)
			{
				if(onTopIntersectOut)
				{
					onTopIntersectOut();
				}
			}
			else if(intersectLocation.top > windowMidHeight)
			{
				if(onBottomIntersectOut)
				{
					onBottomIntersectOut();
				}
			}
			if(onIntersectOut)
			{
				onIntersectOut();
			}
		}


		if(onIntersectChange)
		{
			onIntersectChange(intersectionEvt);
		}
	}
	useEffect(()=>{
		let observer = null; 
		observer = new IntersectionObserver(handleIntersectionChange, { 
			threshold: 0.1,
			...options
		});
		observer.observe(intersectionObserverRef.current); 
		

		return function cleanup() {
			if(observer?.disconnect)
	        {
	            observer.disconnect();
	        }
		};
	},[])

	return (<span ref={intersectionObserverRef}>{children}</span>);
}

/*
bottom: 155.828125
height: 19.1875
left: 0
right: 1
top: 136.640625
width: 1
x: 0
y: 136.640625


bottom: 111.625
height: 19.1875
left: 0
right: 1
top: 92.4375
width: 1
x: 0
y: 92.4375
*/